import { useEffect, useState } from 'react'
import { AppProviders } from './providers'
import { AppRouter } from './router'
import { SplashScreen } from '@/widgets/SplashScreen'
import { DebugPanel } from '@/widgets/DebugPanel/DebugPanel'
import { ErrorBoundary } from '@/shared/ui/ErrorBoundary'
import { useBuildVersionStore } from '@/shared/lib/build-version-guard'

// Filet de secours pour les sessions tres longues sans jamais quitter l'onglet (le declencheur
// principal reste le retour sur l'onglet -- focus/visibilitychange, ci-dessous).
const BUILD_VERSION_SAFETY_NET_MS = 5 * 60 * 1000

export function App() {
  const [showSplash, setShowSplash] = useState(false) // temporairement désactivé

  // Garde de version du build client (backlog #10597) : capture la reference au demarrage, puis
  // revérifie sur chaque retour reel sur l'onglet (le moment ou Fabrice regarde) plus un filet a
  // basse frequence pour les sessions qui restent des heures sur le meme onglet sans le quitter.
  // Ne recharge jamais seul -- signale uniquement (bandeau dans ChatPage.tsx, action de Fabrice).
  useEffect(() => {
    useBuildVersionStore.getState().init()

    const onTabReturn = () => {
      useBuildVersionStore.getState().clearDismissed()
      void useBuildVersionStore.getState().check()
    }
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') onTabReturn()
    }
    const onSafetyNet = () => {
      // Filet de secours uniquement : ne remet PAS le bandeau au premier plan (dismissed
      // inchange), il ne fait que rafraichir la detection en tache de fond.
      void useBuildVersionStore.getState().check()
    }

    document.addEventListener('visibilitychange', onVisibilityChange)
    window.addEventListener('focus', onTabReturn)
    const intervalId = window.setInterval(onSafetyNet, BUILD_VERSION_SAFETY_NET_MS)

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
      window.removeEventListener('focus', onTabReturn)
      window.clearInterval(intervalId)
    }
  }, [])

  return (
    <ErrorBoundary name="App">
      {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />}
      <AppProviders>
        {/* Colonne flex pleine hauteur : l'app occupe l'espace restant (flex:1),
            le DebugPanel docké réserve sa hauteur en flux normal (non-overlay) —
            quand il est fermé, il ne rend rien et l'app reprend 100% de la hauteur. */}
        <div style={{ display: 'flex', flexDirection: 'column', height: '100dvh' }}>
          <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
            <AppRouter />
          </div>
          <DebugPanel />
        </div>
      </AppProviders>
    </ErrorBoundary>
  )
}
